import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavLink, NavRoleMapping, NavTree } from './navigation.models';
import { environment as config } from '../../../../environments/environment';


@Injectable()
export class NavigationService {
  //public baseUrl = 'http://localhost:5500';  // Example API (You can replace with your API)
  public baseUrl = config.urls.apiUrl;
  // #region  Navigation Links
  private readonly _listNavLinkUrl: string = '/api/Navigation/GetallNavLink';
  private readonly _lisParenttNavLinkUrl: string = '/api/Navigation/GetParentNavLink';
  private readonly _addNavLinkUrl: string = '/api/Navigation/AddNavLink';
  private readonly _updNavLinkUrl: string = '/api/Navigation/UpdateNavLink';
  private readonly _lisParenttNavLinkUrl1: string = '/api/Navigation/GetAllParentNavLink';
  private readonly _getMenuItemsUrl: string = '/api/Navigation/getMenuItems';

  get lisParenttNavLinkUrl() { return this.baseUrl + this._lisParenttNavLinkUrl; }
  get listNavLinkUrl() { return this.baseUrl + this._listNavLinkUrl; }
  get addNavLinkUrl() { return this.baseUrl + this._addNavLinkUrl; }
  get updNavLinkUrl() { return this.baseUrl + this._updNavLinkUrl; }
  get lisParenttNavLinkUrl1() { return this.baseUrl + this._lisParenttNavLinkUrl1; }
  get getMenuItemsUrl() { return this.baseUrl + this._getMenuItemsUrl; }


  constructor(private http: HttpClient) { }

  protected get requestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage['authToken'] || '{}',
      'Accept': 'application/json, text/plain, */*',
      // 'sessionId': JSON.parse(localStorage['authToken'] ?? '{}').sessionId ?? 0,
      'Content-Type': 'application/json'
    });

    return { headers };
  }

  rkParentNavLinkGetEndpoint<T>(data: any): Observable<T> {
    return this.http.post<T>(this.lisParenttNavLinkUrl, data, this.requestHeaders)
  }
  rkParentNavLinkGetEndpoint1<T>(data: any): Observable<T> {
    return this.http.post<T>(this.lisParenttNavLinkUrl1, data, this.requestHeaders)
  }

  rkNavLinkGetEndpoint<T>(data: any): Observable<T> {
    return this.http.post<T>(this.listNavLinkUrl, data, this.requestHeaders)
  }

  rkNavLinkAddEndpoint<T>(rkNavLink: any): Observable<T> {

    return this.http.post<T>(this.addNavLinkUrl, JSON.stringify(rkNavLink), this.requestHeaders)
  }

  rkNavLinkUpdateEndpoint<T>(rkFacility: any): Observable<T> {
    return this.http.put<T>(this.updNavLinkUrl, JSON.stringify(rkFacility), this.requestHeaders)
  }

  listNavLinkData(data: any) {
    return this.rkNavLinkGetEndpoint(data);
  }
  listParentNavLinkData(data: any) {
    return this.rkParentNavLinkGetEndpoint(data);
  }

  listAllParentNavLinkData(data: any) {
    return this.rkParentNavLinkGetEndpoint1(data);
  }

  UpdateNavLink(rkNavLink: NavLink) {
    return this.rkNavLinkUpdateEndpoint<NavLink>(rkNavLink);
  }
  AddNavLink(rkNavLink: NavLink) {
    return this.rkNavLinkAddEndpoint<NavLink>(rkNavLink);
  }

  private sub = new BehaviorSubject(null);
  private allRole = new BehaviorSubject(null);
  private closesub = new BehaviorSubject(null);
  subj$ = this.sub.asObservable();
  closesub$ = this.closesub.asObservable();
  // #endregion 
  private readonly _listNavTreeUrl: string = '/api/Navigation/GetallNavTree';
  private readonly _addNavTreeUrl: string = '/api/Navigation/AddNavTree';
  private readonly _updNavTreeUrl: string = '/api/Navigation/UpdateNavTree';


  get listNavTreeUrl() { return this.baseUrl + this._listNavTreeUrl; }
  get addNavTreeUrl() { return this.baseUrl + this._addNavTreeUrl; }
  get updNavTreeUrl() { return this.baseUrl + this._updNavTreeUrl; }


  rkNavTreeGetEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.listNavTreeUrl, this.requestHeaders)
  }

  rkNavTreeAddEndpoint<T>(rkNavTree: any): Observable<T> {

    return this.http.post<T>(this.addNavTreeUrl, JSON.stringify(rkNavTree), this.requestHeaders)
  }

  rkNavTreeUpdateEndpoint<T>(rkNavTree: any): Observable<T> {
    return this.http.put<T>(this.updNavTreeUrl, JSON.stringify(rkNavTree), this.requestHeaders)
  }

  listNavTreeData() {
    return this.rkNavTreeGetEndpoint();
  }
  AddNavTree(rkNavTree: NavTree) {
    return this.rkNavTreeAddEndpoint<NavTree>(rkNavTree);
  }
  UpdateNavTree(rkNavTree: NavTree) {
    return this.rkNavTreeUpdateEndpoint<NavTree>(rkNavTree);
  }
  private treesub = new BehaviorSubject(null);
  private treeclosesub = new BehaviorSubject(null);
  treesubj$ = this.sub.asObservable();
  treeclosesub$ = this.closesub.asObservable();





  private readonly _listNavRolesUrl: string = '/api/Navigation/GetallNavRoles';
  private readonly _listNavRolesmapUrl: string = '/api/Navigation/GetallRoleMapping';
  private readonly _updNavRoleUrl: string = '/api/Navigation/UpdateNavRole';
  private readonly _addNavRoleUrl: string = '/api/Navigation/AddNavRole';

  get listNavRolesUrl() { return this.baseUrl + this._listNavRolesUrl; }
  get listNavmapRolesUrl() { return this.baseUrl + this._listNavRolesmapUrl; }
  get updNavRoleUrl() { return this.baseUrl + this._updNavRoleUrl; }
  get addNavRoleUrl() { return this.baseUrl + this._addNavRoleUrl; }


  rkNavRolesGetEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.listNavRolesUrl, this.requestHeaders)
  }
  rkNavRolesMapGetEndpoint<T>(data: any): Observable<T> {
    return this.http.post<T>(this.listNavmapRolesUrl, data, this.requestHeaders)
  }
  rkNavRoleAddEndpoint<T>(rkNavRole: any): Observable<T> {

    return this.http.post<T>(this.addNavRoleUrl, JSON.stringify(rkNavRole), this.requestHeaders)
  }
  rkNavRoleUpdateEndpoint<T>(rkNavRole: any): Observable<T> {
    return this.http.put<T>(this.updNavRoleUrl, JSON.stringify(rkNavRole), this.requestHeaders)
  }

  listNavRolesData() {
    return this.rkNavRolesGetEndpoint();
  }
  listNavMapRolesData(obj: any) {
    return this.rkNavRolesMapGetEndpoint(obj);
  }

  AddNavRole(rkNavRole: NavRoleMapping) {
    return this.rkNavRoleAddEndpoint<NavRoleMapping>(rkNavRole);
  }
  UpdateNavRole(rkNavTree: NavRoleMapping) {
    return this.rkNavRoleUpdateEndpoint<NavRoleMapping>(rkNavTree);
  }
  private rolesub = new BehaviorSubject(null);
  private roleclosesub = new BehaviorSubject(null);
  rolesub$ = this.sub.asObservable();
  allRole$ = this.allRole.asObservable();
  roleclosesub$ = this.closesub.asObservable();
  sendRoleDataDialog(data: any) {
    this.sub.next(data);
  }

  sendAllRoleData(data: any) {
    this.allRole.next(data);
  }
  sendRoleCloseDialog(data: any) {
    this.closesub.next(data);
  }

  getMenuItems() {
    return this.getMenuItemsEndpoint<any[]>();
  }

  getMenuItemsEndpoint<T>(): Observable<T> {
    const endpointUrl = this.getMenuItemsUrl;
    return this.http.get<T>(endpointUrl, this.requestHeaders)
  }
}
